import { Layout } from "react-admin";
import MyAppBar from "./MyAppBar";
import MyMenu from "./MyMenu";
import { OrganizationDetailsCRUDProvider } from "../providers/organizationDetailsCRUDProvider";
import LocaleSyncer from "../providers/LocaleSyncer";

export const MyLayout = (props: object) => {
  return (
    <OrganizationDetailsCRUDProvider>
      <LocaleSyncer />
      <Layout {...props} appBar={MyAppBar} menu={MyMenu} />
    </OrganizationDetailsCRUDProvider>
  );
};
